import React from 'react';
import { AvatarImage } from './AvatarImage';
import { UserTooltip } from './UserTooltip';

export function UserAvatar({ user, src, className, size = 48, showTooltip = true, tooltipSide = "bottom", ...props }) {
  const avatar = (
    <AvatarImage
      user={user}
      src={src}
      className={className}
      size={size}
      {...props}
    />
  );

  // If explicit false or no user data to show tooltip for
  if (!showTooltip || !user) {
    return avatar;
  }

  // Wrap with tooltip
  return (
    <UserTooltip user={user} side={tooltipSide}>
      {avatar}
    </UserTooltip>
  );
}
